// Fallback values shown until dashboardApi.fetchOverview() resolves (or if it
// fails). They match the backend service's own placeholder values 1:1, so the
// dashboard looks identical whether the data came from the API or from here.
export default {
  stats: {
    bookings: {
      count: 281,
      percentage: {color: "success", amount: "+55%", label: "than lask week"},
    },
    todaysUsers: {
      count: "2,300",
      percentage: {color: "success", amount: "+3%", label: "than last month"},
    },
    revenue: {
      count: "34k",
      percentage: {color: "success", amount: "+1%", label: "than yesterday"},
    },
    followers: {
      count: "+91",
      percentage: {color: "success", amount: "", label: "Just updated"},
    },
  },
  charts: {
    websiteViews: {
      labels: ["M", "T", "W", "T", "F", "S", "S"],
      datasets: {label: "Sales", data: [50, 20, 10, 22, 50, 10, 40]},
    },
    dailySales: {
      labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      datasets: {label: "Mobile apps", data: [50, 40, 300, 320, 500, 350, 200, 230, 500]},
    },
    completedTasks: {
      labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      datasets: {label: "Desktop apps", data: [50, 40, 300, 220, 500, 250, 400, 230, 500]},
    },
  },
  projects: {
    doneThisMonthLabel: "30 done",
    rows: [
      {company: "Material UI XD Version", membersCount: 4, budget: "$14,000", completion: 60},
      {company: "Add Progress Track", membersCount: 2, budget: "$3,000", completion: 10},
      {company: "Fix Platform Errors", membersCount: 2, budget: "Not set", completion: 100},
      {company: "Launch our Mobile App", membersCount: 4, budget: "$20,500", completion: 100},
      {company: "Add the New Pricing Page", membersCount: 1, budget: "$500", completion: 25},
      {company: "Redesign New Online Shop", membersCount: 2, budget: "$2,000", completion: 40},
    ],
  },
  ordersOverview: {
    monthlyChangePercent: 24,
    items: [
      {color: "success", icon: "notifications", title: "$2400, Design changes", dateTime: "22 DEC 7:20 PM"},
      {color: "error", icon: "inventory_2", title: "New order #1832412", dateTime: "21 DEC 11 PM"},
      {color: "info", icon: "shopping_cart", title: "Server payments for April", dateTime: "21 DEC 9:34 PM"},
      {color: "warning", icon: "payment", title: "New card added for order #4395133", dateTime: "20 DEC 2:20 AM"},
      {color: "primary", icon: "vpn_key", title: "New card added for order #4395133", dateTime: "18 DEC 4:54 AM"},
    ],
  },
};
